import { fork, take, put, call } from 'redux-saga/effects';

import { topPlayersReducer } from './reducer';
import apiService from '../../api/apiServices/apiService';

import { toast } from 'react-toastify';
import type { TopPlayerDto } from '@poker-stats/contracts';
import { generateFilters } from '../StatPage/sagas';

function* watchLoadTopPlayers() {
  while (true) {
    const { payload }: ReturnType<typeof topPlayersReducer.actions.loadTopPlayers> = yield take(
      topPlayersReducer.actions.loadTopPlayers,
    );

    const {
      customDateFilterValue,
      dateFilterValue,
      limitFilterValue,
      tableSizeFilterValue,
      pokersiteFilterValue,
    } = payload;

    const filters = generateFilters(
      tableSizeFilterValue,
      limitFilterValue,
      dateFilterValue,
      customDateFilterValue,
      pokersiteFilterValue,
    );

    const { success, reject }: { success: { payload: Array<TopPlayerDto> }; reject: any } =
      yield call([apiService, apiService.getTopPlayers], filters);

    if (success) {
      yield put(topPlayersReducer.actions.setLoadedTopPlayers(success.payload));
    }
    if (reject) {
      toast.error(reject.payload.message);
    }
  }
}

export default function* topPlayersSaga() {
  yield fork(watchLoadTopPlayers);
}
